/* eslint-disable */

"use strict";

/** NB Customization Reason:
 *  This adyenCheckout.js is called in 
 *  org_newbalance\cartridges\org_newbalance\cartridge\client\default\js\checkout.js
 *  and 
 *  org_newbalance\cartridges\org_newbalance\cartridge\client\default\js\checkout\checkout.js
 *  to initiate the adyen checkout process. The reason for this customization is to have the
 *  the customized renderGenericComponent() called on the custom adyenCheckout in these file.
 *  Besides that, the only customizations in this file are rerouting require statements.
 *  Lint disable added to not modify vendor code too much.
 *  Also not doing adyen validation if the payment block is hidden which would indicate a
 *  full gift card payment
 *  */
var store = require('../../../../../../../link_adyen/cartridges/app_adyen_SFRA/cartridge/store');
var _require = require('./adyen_checkout/renderGenericComponent'),
  renderGenericComponent = _require.renderGenericComponent;
var _require2 = require('./adyen_checkout/checkoutConfiguration'),
  setCheckoutConfiguration = _require2.setCheckoutConfiguration,
  actionHandler = _require2.actionHandler;
var _require3 = require('adyen/adyen_checkout/helpers'), // NB Customization
  assignPaymentMethodValue = _require3.assignPaymentMethodValue,
  showValidation = _require3.showValidation,
  paymentFromComponent = _require3.paymentFromComponent;
var _require4 = require('adyen/adyen_checkout/validateComponents'), // NB Customization
  validateComponents = _require4.validateComponents;
$('#dwfrm_billing').submit(function apiRequest(e) {
  e.preventDefault();
  var form = $(this);
  var url = form.attr('action');
  $.ajax({
    type: 'POST',
    url: url,
    data: form.serialize(),
    async: false,
    success: function success(data) {
      store.formErrorsExist = 'fieldErrors' in data;
    }
  });
});
setCheckoutConfiguration();
if (window.cardholderNameBool !== 'null') {
  store.checkoutConfiguration.paymentMethodsConfiguration.card.hasHolderName = true;
  store.checkoutConfiguration.paymentMethodsConfiguration.card.holderNameRequired = true;
}
if (window.googleMerchantID !== 'null' && window.Configuration.environment.includes('live')) {
  var id = 'merchantId';
  store.checkoutConfiguration.paymentMethodsConfiguration.paywithgoogle.configuration[id] = window.googleMerchantID;
  store.checkoutConfiguration.paymentMethodsConfiguration.googlepay.configuration[id] = window.googleMerchantID;
}

// Submit the payment
$('button[value="submit-payment"]').on('click', function () {
  if (store.paypalTerminatedEarly) {
    paymentFromComponent({
      cancelTransaction: true,
      merchantReference: document.querySelector('#merchantReference').value
    });
    store.paypalTerminatedEarly = false;
  }
  if (document.querySelector('#selectedPaymentOption').value === 'AdyenPOS') {
    document.querySelector('#terminalId').value = document.querySelector('#terminalList').value;
  }
  // NB Customization - adding in payment container visibility check
  if ((document.querySelector('#selectedPaymentOption').value === 'AdyenComponent' || document.querySelector('#selectedPaymentOption').value === 'CREDIT_CARD') && !$('.payment-container').hasClass('d-none')) {
    assignPaymentMethodValue();
    validateComponents();
    return showValidation();
  }
  return true;
});
module.exports = {
  renderGenericComponent: renderGenericComponent,
  actionHandler: actionHandler
};